import AddBudgets from "./AddBudgets";
import { useLoadingState } from "../../../../../Hooks";
import { useEffect, useState } from "react";
import { BudgetPricingStrategyModel, YearDataModel } from "../../../../../Generated/Commodity-Management-Api";
import { CommodityManagementApi } from "../../../../../Apis/Apis";
import { StoneXLoading } from "../../../../StoneX";

export default function AddBudgetsPage() {
  const budgetYearsLoadingState = useLoadingState();
  const pricingStrategiesLoadingState = useLoadingState();

  const [ years, setYears ] = useState<YearDataModel[]>([]);
  const [ pricingStrategies, setPricingStrategies ] = useState<BudgetPricingStrategyModel[]>();

  const queryParams = new URLSearchParams(location.search);
  const getParams = (param: string) => (queryParams.get(param) ? parseInt(queryParams.get(param)!) : undefined);

  useEffect(() => {
    CommodityManagementApi.listBudgetYears(budgetYearsLoadingState.setLoadingState).then((q) => setYears(q.data.rows ?? []));
    CommodityManagementApi.listPricingStrategies(pricingStrategiesLoadingState.setLoadingState).then((q) => setPricingStrategies(q.data.rows ?? []));
  }, []);


  if (budgetYearsLoadingState.isLoading() || pricingStrategiesLoadingState.isLoading()) {
    return <StoneXLoading show/>
  } else {
    return <AddBudgets years={years} pricingStrategies={pricingStrategies} onClose={() => {}} onSave={() => {}}/>
  }

}